const defaultProps = {
    alignment: 'left',
    color: 'primary',
    iconPos: 'left',
    sizing: 'medium',
    tabListProps: {},
    variant: 'plain',
};

export { defaultProps };
//# sourceMappingURL=constants.js.map
